import { IDomErrorHandler, IoCContainer, ISidebarModule, WebCoreIoCKeys } from '../..';
import { WebCoreConstans } from '../../constans/web-core.constans';
import { IWebCoreIoCContainer } from '../implentation/web-core-ioc-container/web-core-ioc-container.interface';
import { DiagnosticReportSaveModel, DiagnosticTypeEnum } from '../../pocos/diagnostic.classes';

export class ErrorManagementModule implements ISidebarModule {
    public static SIDEBAR_BUTTON_CLASS: string = 'wecdev-bar-button';
    public isDrawn = false;
    public name = 'Error Management Module';

    private get ioc(): IWebCoreIoCContainer {
        return IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
    }

    private get domErrorHandler(): IDomErrorHandler {
        return IoCContainer.get(WebCoreIoCKeys.IDomErrorHandler);
    }

    public drawModule(container: HTMLElement): void {
        if (this.isDrawn) {
            return;
        }

        let clientErrorsString: string = this.domErrorHandler.getClientErrorString();
        let button: HTMLButtonElement = document.createElement('button');
        button.className = ErrorManagementModule.SIDEBAR_BUTTON_CLASS;

        if (clientErrorsString === null || clientErrorsString === '') {
            button.innerHTML = this.ioc.translation.getMessage('error_management_no_error');
        } else {
            button.innerHTML = this.ioc.translation.getMessage('error_management_report_all_errors');
            button.addEventListener('click', (e: Event): boolean => {
                this.reportErrors(e.target as HTMLButtonElement);
                return false;
            });
        }

        container.appendChild(button);
        this.isDrawn = true;
    }

    public async reportErrors(button: HTMLButtonElement) {
        let clientErrorsString: string = this.domErrorHandler.getClientErrorString();
        if (clientErrorsString != null && clientErrorsString != '') {
            let diagnosticReportModel: DiagnosticReportSaveModel = {
                content: clientErrorsString,
                type: DiagnosticTypeEnum.Error,
            };

            try {
                this.ioc.eventHandler.emit(WebCoreConstans.REPORT_ALL_ERROR_EVENT, diagnosticReportModel);
                this.domErrorHandler.clearDomErrorStorage();
                this.ioc.notificationService.createSuccessTranslateMessage('error_management_sent_success');
                button.innerHTML = this.ioc.translation.getMessage('error_management_no_error');
            } catch (error) {
                this.ioc.notificationService.createDangerTranslateMessage('error_management_sent_failed');
            }
        }
    }
}
